import App from '../App';
import DraggableArea from './DraggableArea';
import {tns} from '../../../node_modules/tiny-slider/src/tiny-slider';
import TextString from './TextString';

class NewsDraggableList{
    constructor(element){
        this.main = element;
        
        this._dataItems = null;
        this._holderItems = this.main.querySelector('.holder_items');
        this._pager = this.main.querySelector('.slider-pager');

        NewsDraggableList.categories = JSON.parse(this.main.getAttribute('data-categories'));
        
        this._draggable = new DraggableArea(this.main);
        
        this.set(JSON.parse(this.main.getAttribute('data-items')));
        this._draggable.reset();
        
    }

    set(dataItems){
        this._dataItems = dataItems;

        this._holderItems.innerHTML = '';
        
        this._dataItems.forEach((dataItem, index)=>{
            let item = new NewsDraggableListItem(dataItem, index);
            this._holderItems.appendChild(item.main);
        })
        
        //if(this._slider){
        //    this._slider.destroy();
        //}

        var slider = tns({
            container: this.main.querySelector('.slider-carousel'),
            nav: false,
            controls: false,
            mouseDrag: true,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            center: true,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            edgePadding: 15,
            responsive: {
                370: {
                    edgePadding: 0,
                },
                500: {
                    items: 2,
                },
                768: {
                    items: 3
                },
                992: {
                    disable: true,
                },
                1440: {
                        items: 4,
                },
            }
        });

        this._pager.children[1].innerHTML = ("00" + dataItems.length).slice(-2);
        //console.log(this._pager);

        if(slider){
            slider.events.on('indexChanged', this._onSliderIndexChanged.bind(this));
        }
        
        this._draggable.reset();

        if(typeof App.wow != 'undefined'){
            setTimeout(()=>{
                App.wow.sync();
            })
        }
        
    }

    _onSliderIndexChanged(e){
        //console.log(this._pager);
        this._pager.children[0].innerHTML = ("00" + e.displayIndex).slice(-2);
    }
}

class NewsDraggableListItem{
    constructor(data, indexAnimation){

        this._data = data;

        this.main = document.createElement('div');

        let arrDate = this._data.datetime.split(' ')[0].split('-');
        let date = `${parseInt(arrDate[2], 10)} ${App.monthsShort[parseInt(arrDate[1], 10) - 1]} ${arrDate[0]}`;
        let url = App.baseUrl + App.sitemap.news_detail.slug + this._data.slug;
        
        this.main.innerHTML = /*html*/ `<div class="slider-carousel__item" draggable="false">
                                            <a href="${url}" class="card-new wow fadeInUp" data-wow-delay="${(0.1 * indexAnimation)}s" draggable="false">
                                                <div class="card-new__img" draggable="false">
                                                    <img src="${App.filesPath + this._data.area_thumb}" alt="Sample" draggable="false">
                                                    <div class="card-new__tag card-new__tag--${this._data.category}" draggable="false">${NewsDraggableList.categories[this._data.category]}</div>
                                                </div>
                                                <div class="card-new__title" draggable="false">${(new TextString(this._data.title)).cut(60)}</div>
                                                <div class="card-new__description" draggable="false">${(new TextString(this._data.smalltext)).cut(150)}</div>
                                                <div class="card-new__footer" draggable="false">
                                                    <div class="card-new__collaborators">
                                                        <div class="collaborators">
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="card-new__date" draggable="false">${date}</div>
                                                </div>
                                            </a>
                                        </div>`;
                
        
        let visibleAuthors = this._data.authors.slice(0, 2);
        let authorsHolder = this.main.querySelector('.collaborators');

        visibleAuthors.forEach((author)=>{
            authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><img src="${App.filesPath + author.image}" class="collaborators__thumb"></div>`);
        });

        let rest = this._data.authors.length - visibleAuthors.length;

        if(rest > 0){
            authorsHolder.insertAdjacentHTML('beforeend', /*html*/`<div class="collaborators__item"><div class="collaborators__thumb collaborators__thumb--others">+${rest}</div></div>`);    
        }
        
        this.main = this.main.firstChild; 
    }
}

export default NewsDraggableList;